// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2hbOG","select":"Header_select__BMAz4","clinic":"Header_clinic__2jtu2"};